import React, {useRef, useEffect} from "react";
import {showPolicyPage} from "@awe-web/shared/lib";

export const PolicyPage = () => {
  const rootNode = useRef();
  useEffect(() => {
    showPolicyPage(rootNode.current);
  }, []);

  return (
    <div ref={rootNode} className="consent-manager" />
  );
};
PolicyPage.propTypes = {
};
